import requestFunctions from "../../functions/requestFunctions";


export const state = {
  MARKETPLACES_ITEM: {},
  MARKETPLACES_LIST: [],
  MARKETPLACES_TABLE_DATA: [],
  MARKETPLACES_ARRAY_DATA: [],
  MARKETPLACES_TOTAL_ROWS: 0
}

export const getters = {
  GET_MARKETPLACES_ITEM: (state) => {
    return state.MARKETPLACES_ITEM;
  },
  GET_MARKETPLACES_LIST: (state) => {
    return state.MARKETPLACES_LIST;
  },
  GET_MARKETPLACES_TABLE_DATA: (state) => {
    return state.MARKETPLACES_TABLE_DATA;
  },
  GET_MARKETPLACES_ARRAY_DATA: (state) => {
    return state.MARKETPLACES_ARRAY_DATA;
  },
  GET_MARKETPLACES_TOTAL_ROWS: (state) => {
    return state.MARKETPLACES_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_MARKETPLACES_ITEM(state, item) {
    state.MARKETPLACES_ITEM = item;
  },

  UPDATE_MARKETPLACES_LIST(state, list) {
    
    state.MARKETPLACES_LIST = list.data;

    state.MARKETPLACES_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.MARKETPLACES_TABLE_DATA = [];
    state.MARKETPLACES_ARRAY_DATA = [];

    list.forEach(el => {

      state.MARKETPLACES_TABLE_DATA.push({
        'uuid' : el.uuid,
        'id'   : el.id,
        'name' : el.name,
        'code' : el.code,
        'url'  : el.url,
        'comments'   : el.comments,
        'created_at' : el.created_at,
        'updated_at' : el.updated_at,
      });

      state.MARKETPLACES_ARRAY_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name
      });
    });
  },
}

export const actions = {

  async FETCH_MARKETPLACES_ITEM({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/marketplaces/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_MARKETPLACES_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_MARKETPLACES_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.tradeanalytic.ru/v1/marketplaces';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_MARKETPLACES_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_MARKETPLACES_CREATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/marketplaces';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_MARKETPLACES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/marketplaces/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_MARKETPLACES_DELETE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/marketplaces/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}